// extracted by mini-css-extract-plugin
module.exports = {"companyNews":"DDld","headerWrap":"DDkv","prevBtn":"DDlb","nextBtn":"DDk-","headerLink":"DDkx","header":"DDap","slider":"DDh3"};